type GuardCallback = (proceed: () => void) => void;

let guard: GuardCallback | null = null;

const navigationGuard = {
  register(fn: GuardCallback) {
    guard = fn;
  },
  unregister() {
    guard = null;
  },
  navigate(proceed: () => void) {
    if (guard) {
      guard(proceed);
    } else {
      proceed();
    }
  },
};

export default navigationGuard;
